import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { computed } from 'vue'
import { useStore } from 'vuex'

import CateringHome from '@/view/catering/CateringHome.vue'
import FranchiseHome from '@/view/franchise/FranchiseHome.vue'


export default {
  __name: 'DashboardHome',
  setup(__props) {

const store = useStore()
const isFranchise = computed(() => store.getters.isFranchise)

return (_ctx, _cache) => {
  return (isFranchise.value)
    ? (_openBlock(), _createBlock(FranchiseHome, { key: 0 }))
    : (_openBlock(), _createBlock(CateringHome, { key: 1 }))
}
}

}